module.exports = __webpack_public_path__ + "img/eggbar.c6b83b32.png";